<template>
  <ReportAgent
    :urls="urls"
    :mandatory-filter="[
      {
        name: 'date_range',
        title: 'Date range',
        valueFieldName: '.date',
      },
    ]"
  />
</template>

<script>
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import ReportAgent from "@/own/components/reports/ReportAgent";
export default {
  name: "SkuMovement",
  components: { ReportAgent },
  data: () => ({
    urls: {
      data_url: "/reports/reportSkuMovement",
      show_url: "/reports/reportSkuMovement/show",
    },
  }),
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
  },
};
</script>
